import { $api } from '../y/api';
import { YId, YTaggedId } from '../y/types';

export type CBookingPartStatus = 'confirmed' | 'cancelled' | 'standby' | 'standby_reserved' | 'reserved';

export interface CBookingPart {
    status: CBookingPartStatus;
}

export type CRating = 'up' | 'down';

export type CBookingId = YTaggedId<'c_booking'>;
export type CBookingPartId = YTaggedId<'c_booking_part'>;

export interface CBooking {
    id: CBookingId;
    is_test: boolean;
    is_checked_in: boolean;
    is_tickets_sent: boolean;
    session_id: YId;
    user_id: YId;
    token: string;
    number: string;
    quantity_booked: number;
    group_id?: YId;
}

export function cBookingPartUnbook(booking_part_id: CBookingPartId, is_late?: boolean) {
    return $api.POST(`c/booking_part/${booking_part_id}/unbook`, { is_late });
}

export function cBookingPartChangeQuantity(booking_part_id: CBookingPartId, quantity: number, is_late?: boolean) {
    return $api.POST(`c/booking_part/${booking_part_id}/change_quantity`, { quantity, is_late });
}

export function cBookingPartReject(booking_part_id: CBookingPartId) {
    return $api.POST(`c/booking_part/${booking_part_id}/reject`);
}

export function cBookingPartConfirm(booking_part_id: CBookingPartId) {
    return $api.POST(`c/booking_part/${booking_part_id}/confirm`);
}

export function cBookingRate(booking_id: CBookingId, rating: CRating) {
    return $api.POST(`c/booking/${booking_id}/rate`, { rating });
}

export function cBookingReview(booking_id: CBookingId, text: string) {
    return $api.POST(`c/booking/${booking_id}/review`, { text });
}
